(function HotelEngineRoomFilter($, Adzuki)
{
    'use strict';

    const CHECK_ICON = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    const SEARCH_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    const AMENITIES_VISIBLE = 8;
    const PRICE_GAP           = 10;

    const component = {
        emits: ['filtered-rooms', 'room-filters'],
        props: {
            rooms: {
                type    : Object,
                required: true,
                default : () => ({})
            },
            numNights: {
                type    : Number,
                required: false,
                default : 1
            },
            numRooms: {
                type    : Number,
                required: false,
                default : 1
            },
            initialFilters: {
                type    : Object,
                required: false,
                default : () => ({})
            },
            showPayLater: {
                type   : Boolean,
                default: false
            }
        },
        template: `
          <div class="he-room-filter">
            <button
                type="button"
                class="he-room-filter__toggle"
                :aria-expanded="showFilters ? 'true' : 'false'"
                aria-controls="he-room-filter-panel"
                @click="toggleFilters"
            >
              Filter Rooms
              <span class="he-room-filter__toggle-icon">{{ showFilters ? '–' : '+' }}</span>
            </button>

            <div
                id="he-room-filter-panel"
                class="he-room-filter__panel-wrap"
                :class="{ 'he-room-filter__panel-wrap--open': showFilters }"
            >
              <div class="he-room-filter__panel-inner">
                <div class="he-room-filter__panel">
                  <div class="he-room-filter__head">
                    <div class="he-room-filter__search">
                      <span class="he-room-filter__search-icon" v-html="searchIcon"></span>
                      <input
                          id="room-filter-input"
                          type="text"
                          class="he-room-filter__search-input"
                          placeholder="Search room name or feature…"
                          v-model="searchTerm"
                          autocomplete="off"
                      >
                    </div>
                  </div>

                  <div v-if="activeFilterCount > 0" class="he-room-filter__chips-bar">
                    <span class="he-room-filter__chips-label">Active</span>
                    <span
                        v-for="chip in activeChips"
                        :key="chip.key"
                        class="he-room-filter__chip"
                    >
                      <span>{{ chip.label }}</span>
                      <button type="button" aria-label="Remove filter" @click="chip.remove()">&times;</button>
                    </span>
                    <button type="button" class="he-room-filter__clear-all" @click="clearAllFilters">Clear all</button>
                  </div>

                  <div class="he-room-filter__groups">
                    <div class="he-room-filter__group">
                      <h3 class="he-room-filter__group-title">Price / night</h3>
                      <div class="he-room-filter__price-vals">
                        <div class="he-room-filter__price-box">
                          <span>Min</span>
                          <strong v-format-currency.no-decimals="priceMin"></strong>
                        </div>
                        <div class="he-room-filter__price-dash">–</div>
                        <div class="he-room-filter__price-box he-room-filter__price-box--right">
                          <span>Max</span>
                          <strong v-format-currency.no-decimals="priceMax"></strong>
                        </div>
                      </div>
                      <div class="he-room-filter__range">
                        <div class="he-room-filter__range-track"></div>
                        <div class="he-room-filter__range-fill" :style="priceRangeFillStyle"></div>
                        <input
                            type="range"
                            class="he-room-filter__range-input he-room-filter__range-input--min"
                            :min="sliderMin"
                            :max="sliderMax"
                            step="1"
                            v-model.number="priceMin"
                            @input="onPriceMinInput"
                        >
                        <input
                            type="range"
                            class="he-room-filter__range-input he-room-filter__range-input--max"
                            :min="sliderMin"
                            :max="sliderMax"
                            step="1"
                            v-model.number="priceMax"
                            @input="onPriceMaxInput"
                        >
                      </div>
                      <div class="he-room-filter__range-caption">
                        Rooms from <strong v-format-currency.no-decimals="sliderMin"></strong>
                        to <strong v-format-currency.no-decimals="sliderMax"></strong>
                      </div>
                    </div>

                    <div class="he-room-filter__group">
                      <h3 class="he-room-filter__group-title">Beds</h3>
                      <label
                          v-for="(bedSize, idx) in bedSizes"
                          :key="'bed-' + idx"
                          class="he-room-filter__opt"
                      >
                        <input
                            type="checkbox"
                            class="hotel-filter-bed"
                            :value="bedSize"
                            v-model="bedChoice"
                        >
                        <span class="he-room-filter__opt-box" v-html="checkIcon"></span>
                        {{ bedSize }}
                      </label>
                    </div>

                    <div class="he-room-filter__group">
                      <h3 class="he-room-filter__group-title">Booking options</h3>
                      <label class="he-room-filter__opt">
                        <input type="checkbox" v-model="isRefundable">
                        <span class="he-room-filter__opt-box" v-html="checkIcon"></span>
                        Refundable
                      </label>
                      <label v-if="showPayLater" class="he-room-filter__opt">
                        <input type="checkbox" v-model="isPaysLater">
                        <span class="he-room-filter__opt-box" v-html="checkIcon"></span>
                        Pay Later eligible
                      </label>
                      <label class="he-room-filter__opt">
                        <input type="checkbox" v-model="isBreakfastIncluded">
                        <span class="he-room-filter__opt-box" v-html="checkIcon"></span>
                        Breakfast included
                      </label>
                    </div>

                    <div class="he-room-filter__group">
                      <h3 class="he-room-filter__group-title">Amenities</h3>
                      <div class="he-room-filter__amenities-grid">
                        <label
                            v-for="(amenity, idx) in roomAmenities"
                            :key="'amenity-' + idx"
                            v-show="amenitiesExpanded || idx < amenitiesVisibleCount"
                            class="he-room-filter__opt"
                        >
                          <input
                              type="checkbox"
                              class="hotel-filter-amenity"
                              :value="amenity"
                              v-model="amenitySearch"
                          >
                          <span class="he-room-filter__opt-box" v-html="checkIcon"></span>
                          {{ amenity }}
                        </label>
                      </div>
                      <button
                          v-if="roomAmenities.length > amenitiesVisibleCount"
                          type="button"
                          class="he-room-filter__show-more"
                          @click="amenitiesExpanded = !amenitiesExpanded"
                      >
                        {{ amenitiesExpanded ? 'Show fewer amenities' : 'Show all amenities' }}
                      </button>
                    </div>
                  </div>

                  <div class="he-room-filter__foot">
                    <div class="he-room-filter__result-count">
                      Showing <strong>{{ filteredRoomCount }}</strong> of {{ totalRoomCount }} rooms
                    </div>
                    <div class="he-room-filter__foot-actions">
                      <button type="button" class="he-room-filter__btn he-room-filter__btn--ghost" @click="clearAllFilters">
                        Clear all
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `,
        data() {
            return {
                baseUri              : Adzuki.base_uri,
                searchTerm           : '',
                priceMin             : 0,
                priceMax             : 0,
                bedChoice            : [],
                isRefundable         : false,
                isPaysLater          : false,
                isBreakfastIncluded  : false,
                amenitySearch        : [],
                showFilters          : false,
                amenitiesExpanded    : false,
                checkIcon            : CHECK_ICON,
                searchIcon           : SEARCH_ICON,
                amenitiesVisibleCount: AMENITIES_VISIBLE,
                initialFiltersApplied: false,
                filtersReady         : false
            };
        },
        computed: {
            allRoomPrices() {
                const prices     = [];
                const roomsArray = Object.entries(this.rooms || {}).map(([roomName, roomData]) => ({
                    ...roomData,
                    room_name: roomName
                }));

                roomsArray.forEach((room) => {
                    if (room.best_value_rates && Array.isArray(room.best_value_rates)) {
                        room.best_value_rates.forEach((rate) => {
                            const price = this.calculatePerNightPrice(rate);

                            if (price > 0) {
                                prices.push(price);
                            }
                        });
                    }
                });

                return prices;
            },
            minMaxPrices() {
                const prices = this.allRoomPrices;

                if (!prices || prices.length === 0) {
                    return {
                        min: 0,
                        max: 0
                    };
                }

                return {
                    min: Math.floor(Math.min(...prices)),
                    max: Math.ceil(Math.max(...prices))
                };
            },
            sliderMin() {
                return this.minMaxPrices.min;
            },
            sliderMax() {
                if (this.minMaxPrices.max > this.minMaxPrices.min) {
                    return this.minMaxPrices.max;
                }

                return this.minMaxPrices.min + 1;
            },
            hasPriceFilter() {
                if (!this.filtersReady) {
                    return false;
                }

                return this.priceMin > this.sliderMin || this.priceMax < this.sliderMax;
            },
            priceRangeFillStyle() {
                const floor = this.sliderMin;
                const ceil  = this.sliderMax;
                const range = ceil - floor || 1;
                const left  = ((this.priceMin - floor) / range) * 100;
                const width = ((this.priceMax - this.priceMin) / range) * 100;

                return {
                    left : `${Math.max(0, left)}%`,
                    width: `${Math.max(0, width)}%`
                };
            },
            totalRoomCount() {
                return Object.keys(this.rooms || {}).length;
            },
            filteredRoomCount() {
                const filtered = this.filteredRooms;

                if (Array.isArray(filtered)) {
                    return filtered.length;
                }

                return Object.keys(filtered || {}).length;
            },
            activeChips() {
                const chips  = [];
                const search = this.searchTerm.trim();

                if (search) {
                    chips.push({
                        key   : 'search',
                        label : search,
                        remove: () => {
                            this.searchTerm = '';
                        }
                    });
                }

                if (this.hasPriceFilter) {
                    chips.push({
                        key   : 'price',
                        label : `${this.formatCurrency(this.priceMin)} – ${this.formatCurrency(this.priceMax)}`,
                        remove: () => {
                            this.resetPriceRange();
                        }
                    });
                }

                this.bedChoice.forEach((bed) => {
                    chips.push({
                        key   : `bed-${bed}`,
                        label : bed,
                        remove: () => {
                            this.bedChoice = this.bedChoice.filter((item) => item !== bed);
                        }
                    });
                });

                if (this.isRefundable) {
                    chips.push({
                        key   : 'refundable',
                        label : 'Refundable',
                        remove: () => {
                            this.isRefundable = false;
                        }
                    });
                }

                if (this.isPaysLater) {
                    chips.push({
                        key   : 'payLater',
                        label : 'Pay Later eligible',
                        remove: () => {
                            this.isPaysLater = false;
                        }
                    });
                }

                if (this.isBreakfastIncluded) {
                    chips.push({
                        key   : 'breakfast',
                        label : 'Breakfast included',
                        remove: () => {
                            this.isBreakfastIncluded = false;
                        }
                    });
                }

                this.amenitySearch.forEach((amenity) => {
                    chips.push({
                        key   : `amenity-${amenity}`,
                        label : amenity,
                        remove: () => {
                            this.amenitySearch = this.amenitySearch.filter((item) => item !== amenity);
                        }
                    });
                });

                return chips;
            },
            activeFilterCount() {
                return this.activeChips.length;
            },
            activeFilters() {
                const searchTerm          = this.searchTerm.trim();
                const hasSearchTerm       = Boolean(searchTerm);
                const hasPriceFilter      = this.hasPriceFilter;
                const hasAmenityFilter    = this.amenitySearch.length > 0;
                const hasBedFilter        = this.bedChoice.length > 0;
                const hasRefundableFilter = this.isRefundable === true;
                const hasPayLaterFilter   = this.showPayLater && this.isPaysLater;
                const hasBreakfastFilter  = this.isBreakfastIncluded;

                if (
                    !hasSearchTerm
                    && !hasPriceFilter
                    && !hasAmenityFilter
                    && !hasBedFilter
                    && !hasRefundableFilter
                    && !hasPayLaterFilter
                    && !hasBreakfastFilter
                ) {
                    return {};
                }

                return {
                    searchTerm     : hasSearchTerm ? this.searchTerm : null,
                    priceMin       : hasPriceFilter ? this.priceMin : 0,
                    priceMax       : hasPriceFilter ? this.priceMax : 0,
                    perNightPrice  : hasPriceFilter ? this.priceMax : 0,
                    amenitySearch  : hasAmenityFilter ? [...this.amenitySearch] : [],
                    bedSearch      : hasBedFilter ? [...this.bedChoice] : [],
                    refundSearch   : hasRefundableFilter ? this.isRefundable : false,
                    payLaterSearch : hasPayLaterFilter ? this.isPaysLater : false,
                    breakfastSearch: hasBreakfastFilter ? this.isBreakfastIncluded : false
                };
            },
            filteredRooms() {
                const roomsArray = Object.entries(this.rooms || {}).map(([roomName, roomData]) => ({
                    ...roomData,
                    room_name: roomName
                }));

                let results = roomsArray.slice(0);

                const searchTerm          = this.searchTerm.trim().toLowerCase();
                const hasSearchTerm       = Boolean(searchTerm);
                const hasPriceFilter      = this.hasPriceFilter;
                const hasAmenityFilter    = this.amenitySearch.length > 0;
                const hasBedFilter        = this.bedChoice.length > 0;
                const hasRefundableFilter = this.isRefundable === true;
                const hasPayLaterFilter   = this.showPayLater && this.isPaysLater;
                const hasBreakfastFilter  = this.isBreakfastIncluded;

                if (
                    !hasSearchTerm
                    && !hasPriceFilter
                    && !hasAmenityFilter
                    && !hasBedFilter
                    && !hasRefundableFilter
                    && !hasPayLaterFilter
                    && !hasBreakfastFilter
                ) {
                    return this.rooms;
                }

                if (hasSearchTerm) {
                    results = results.filter((room) => {
                        let searchFound = false;

                        const nameMatch = room.room_name && room.room_name.toLowerCase().includes(searchTerm);

                        if (nameMatch) {
                            return nameMatch;
                        }

                        this.toList(room.best_value_rates).forEach((rate) => {
                            const providerData = rate?.provider_data || {};

                            this.toList(providerData.beds).forEach((bed) => {
                                if (
                                    String(bed?.size ?? '').toLowerCase().includes(searchTerm) ||
                                    String(bed?.quantity ?? '').includes(searchTerm)
                                ) {
                                    searchFound = true;
                                }
                            });

                            const amenityMatch = this.toList(providerData.room_amenities).some((amenity) =>
                                this.amenityName(amenity).toLowerCase().includes(searchTerm)
                            );

                            searchFound = searchFound || amenityMatch;
                        });

                        return searchFound;
                    });
                }

                if (hasPriceFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => {
                            const price = this.calculatePerNightPrice(rate);

                            return price > 0 && price >= this.priceMin && price <= this.priceMax;
                        })
                    );
                }

                if (hasAmenityFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => {
                            const roomAmenities = this.toList(rate?.provider_data?.room_amenities)
                                .map((amenity) => this.amenityName(amenity));

                            return this.amenitySearch.every((selected) =>
                                roomAmenities.includes(selected)
                            );
                        })
                    );
                }

                if (hasBedFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => {
                            const beds = this.toList(rate?.provider_data?.beds);

                            return this.bedChoice.every((selected) =>
                                beds.some((bed) => bed?.size === selected)
                            );
                        })
                    );
                }

                if (hasRefundableFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => rate?.refundable)
                    );
                }

                if (hasPayLaterFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => rate?.pay_later_eligible)
                    );
                }

                if (hasBreakfastFilter) {
                    results = results.filter((room) =>
                        this.toList(room.best_value_rates).some((rate) => this.rateHasBreakfast(rate))
                    );
                }

                return results;
            },
            roomAmenities() {
                const roomAmenities = new Set();

                this.toList(this.rooms).forEach((room) => {
                    this.toList(room?.best_value_rates).forEach((rate) => {
                        this.toList(rate?.provider_data?.room_amenities).forEach((amenity) => {
                            const name = this.amenityName(amenity);

                            if (name) {
                                roomAmenities.add(name);
                            }
                        });
                    });
                });

                return Array.from(roomAmenities);
            },
            hasPayLaterRates() {
                return this.toList(this.rooms).some((room) =>
                    this.toList(room?.best_value_rates).some((rate) => rate?.pay_later_eligible)
                );
            },
            bedSizes() {
                const bedSizes = new Set();

                this.toList(this.rooms).forEach((room) => {
                    this.toList(room?.best_value_rates).forEach((rate) => {
                        this.toList(rate?.provider_data?.beds).forEach((bed) => {
                            if (bed?.size) {
                                bedSizes.add(bed.size);
                            }
                        });
                    });
                });

                return Array.from(bedSizes);
            }
        },
        methods: {
            // Rate payloads send lists as an array, an object keyed by id, or nothing at all.
            toList(value) {
                if (Array.isArray(value)) {
                    return value.filter((item) => item !== null && item !== undefined);
                }

                if (value && typeof value === 'object') {
                    return Object.values(value).filter((item) => item !== null && item !== undefined);
                }

                return [];
            },
            amenityName(amenity) {
                if (typeof amenity === 'string') {
                    return amenity.trim();
                }

                return amenity?.mapped_name ? String(amenity.mapped_name).trim() : '';
            },
            calculatePerNightPrice(rate) {
                const prices = Adzuki.HotelEngine.computeRatePrices(rate, {
                    numNights: this.numNights || 1,
                    numRooms : this.numRooms || 1,
                });

                return prices.per_night_per_room;
            },
            formatCurrency(amount) {
                const value = parseFloat(amount);

                if (Number.isNaN(value)) {
                    return '';
                }

                return new Intl.NumberFormat('en-US', {
                    style                : 'currency',
                    currency             : 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(value);
            },
            rateHasBreakfast(rate) {
                const boardInfo = rate?.provider_data?.board_info;

                if (!boardInfo) {
                    return false;
                }

                const items = typeof boardInfo === 'object' ? this.toList(boardInfo) : [boardInfo];

                return items.some((item) => String(item ?? '').toLowerCase().includes('breakfast'));
            },
            resetPriceRange() {
                this.priceMin = this.sliderMin;
                this.priceMax = this.sliderMax;
            },
            clampPriceRange() {
                const floor = this.sliderMin;
                const ceil  = this.sliderMax;

                this.priceMin = Math.max(floor, Math.min(this.priceMin, ceil));
                this.priceMax = Math.max(floor, Math.min(this.priceMax, ceil));

                if (this.priceMax < this.priceMin) {
                    this.priceMax = this.priceMin;
                }
            },
            enforcePriceRange(activeInput) {
                const floor = this.sliderMin;
                const ceil  = this.sliderMax;
                const range = ceil - floor || 1;
                const gap   = Math.min(PRICE_GAP, Math.max(1, range));
                let lo      = this.priceMin;
                let hi      = this.priceMax;

                if (hi - lo < gap) {
                    if (activeInput === 'min') {
                        lo = hi - gap;
                    } else {
                        hi = lo + gap;
                    }
                }

                this.priceMin = Math.max(floor, Math.min(lo, ceil));
                this.priceMax = Math.max(floor, Math.min(hi, ceil));
            },
            onPriceMinInput() {
                this.enforcePriceRange('min');
            },
            onPriceMaxInput() {
                this.enforcePriceRange('max');
            },
            toggleFilters() {
                this.showFilters = !this.showFilters;
            },
            clearAllFilters() {
                this.searchTerm           = '';
                this.bedChoice            = [];
                this.isRefundable         = false;
                this.isPaysLater          = false;
                this.isBreakfastIncluded  = false;
                this.amenitySearch        = [];
                this.amenitiesExpanded    = false;
                this.resetPriceRange();
            },
            applyInitialFilters() {
                const filters = this.initialFilters;

                if (!filters || typeof filters !== 'object' || !Object.keys(filters).length) {
                    return;
                }

                if (filters.searchTerm) {
                    // Shared links can decode this to a non-string; keep it safe for .trim().
                    this.searchTerm = String(filters.searchTerm);
                }

                const floor = this.sliderMin;
                const ceil  = this.sliderMax;

                if (filters.priceMin !== undefined && Number(filters.priceMin) >= floor) {
                    this.priceMin = Math.min(Number(filters.priceMin), ceil);
                }

                if (filters.priceMax !== undefined && Number(filters.priceMax) > 0) {
                    const max = Number(filters.priceMax);

                    if (max >= floor && max <= ceil) {
                        this.priceMax = max;
                    }
                } else if (filters.perNightPrice && Number(filters.perNightPrice) > 0) {
                    const max = Number(filters.perNightPrice);

                    if (max >= floor && max <= ceil) {
                        this.priceMax = max;
                    }
                }

                this.clampPriceRange();

                // Carried-over filters may reference values another hotel/provider
                // offered; only keep the ones this hotel can actually match.
                this.amenitySearch = this.toList(filters.amenitySearch)
                    .filter((amenity) => this.roomAmenities.includes(amenity));

                this.bedChoice = this.toList(filters.bedSearch)
                    .filter((bed) => this.bedSizes.includes(bed));

                this.isRefundable        = Boolean(filters.refundSearch);
                this.isPaysLater         = Boolean(filters.payLaterSearch) && this.hasPayLaterRates;
                this.isBreakfastIncluded = Boolean(filters.breakfastSearch);
            },
            syncInitialFilters() {
                if (!this.allRoomPrices.length) {
                    return;
                }

                if (!this.initialFiltersApplied) {
                    this.resetPriceRange();
                    this.applyInitialFilters();
                    this.initialFiltersApplied = true;
                    this.filtersReady          = true;

                    // Never let carried-over filters hide every room on landing.
                    if (this.totalRoomCount > 0 && this.filteredRoomCount === 0) {
                        this.clearAllFilters();
                    }
                    return;
                }

                this.clampPriceRange();
            },
            emitFilteredRooms(newVal) {
                let finalObject;

                if (Array.isArray(newVal)) {
                    finalObject = Object.fromEntries(
                        newVal.map(({ room_name, ...data }) => [room_name, data])
                    );
                } else {
                    finalObject = newVal || {};
                }

                this.$emit('filtered-rooms', finalObject);
            }
        },
        watch: {
            filteredRooms: {
                handler(newVal) {
                    if (!this.filtersReady) {
                        return;
                    }

                    this.emitFilteredRooms(newVal);
                },
                deep: true
            },
            activeFilters: {
                handler(newVal) {
                    if (!this.filtersReady) {
                        return;
                    }

                    this.$emit('room-filters', newVal || {});
                },
                deep: true
            },
            minMaxPrices: {
                handler() {
                    this.syncInitialFilters();
                }
            },
            rooms: {
                handler() {
                    this.syncInitialFilters();
                },
                deep: false
            }
        },
        mounted() {
            this.syncInitialFilters();
        }
    };

    Adzuki.VueComponents.HotelEngineRoomFilter = component;
}(jQuery, window.Adzuki || {}));
